import { updateAllValues } from "../../domain/subscribe/subscribeModel";
import { UpdateSubscribeStore, updateSubscribeUseCase } from "./updateSubscribeUseCase";

const clearSubscribeUseCase = (store: UpdateSubscribeStore) =>
    updateSubscribeUseCase(store, '', updateAllValues)

export { clearSubscribeUseCase };